module.exports = __webpack_public_path__ + "static/media/icon9.bfe3d179.svg";